export const addReportTemplateList = [
  {
    icon: 'grid.png',
    link: 'datatable',
    title: 'Add table',
    description:
      'Show your data in spreadsheet-style report with rows and columns',
  },
  {
    icon: 'plan.png',
    link: 'summary',
    title: 'Summary',
    description:
      'Show your data in spreadsheet-style report with rows and columns',
  },
  {
    icon: 'result.png',
    link: 'chart',
    title: 'Charts',
    description: 'Show your data in Graphic report',
  },
  {
    icon: 'calendar.png',
    link: 'calendar',
    title: 'Calendar',
    description: 'Show your data in Calendar',
  },
  {
    icon: 'map.png',
    link: 'map',
    title: 'Map',
    description: 'Show your data in Map',
  },
  {
    icon: 'gantt.png',
    link: 'gantt',
    title: 'Gantt',
    description: 'Show your data in interactive Gantt chart',
  },
];

export const addUserTemplateList = [
  {
    title: 'Add User',
    opType: 'ADD_USER_WIZARD',
    isModal: false,
  },
  {
    title: 'Create User',
    opType: 'CREATE_USER',
    isModal: true,
  },
  {
    title: 'Create User in Control Panel',
    opType: 'CREATE_USER_IN_CONTROL_PANEL',
    isModal: false,
  },
];

export const addTableTemplateList = [
  {
    title: 'Add Table',
    opType: 'ADD_TABLE',
    isModal: true,
  },
  {
    title: 'Arrange Table Order',
    opType: 'ARRAGNE_TABLE_ORDER',
    isModal: true,
  },
];

export const addPageDashboardTemplateList = [
  {
    title: 'Add Dashboard',
    opType: '',
    link: 'dashboard/create',
    isModal: false,
  },
  {
    title: 'Add Layout',
    opType: '',
    link: 'layout/create',
    isModal: false,
  },
  {
    title: 'Add Custom Theme',
    opType: '',
    link: 'theme/create',
    isModal: false,
  },
  {
    title: 'Add Page',
    opType: '',
    link: 'pages/create',
    isModal: false,
  },
  {
    title: 'Add Superset Dashboard',
    opType: '',
    link: 'superset-dashboard/create',
    isModal: false,
  },
  {
    title: 'Add OG Insights Charts',
    opType: '',
    link: 'metabase-dashboard/create',
    isModal: false,
  },
];

export const addFormTemplateList = [
  {
    icon: 'grid.png',
    link: 'web',
    title: 'Web',
    description: 'Create a web form',
  },
  {
    icon: 'plan.png',
    link: 'mobile',
    title: 'Mobile',
    description: 'Create a mobile form',
  },
  {
    icon: 'result.png',
    link: 'pdf',
    title: 'PDF',
    description: 'Create a PDF form',
  },
  {
    icon: 'word.png',
    link: 'word',
    title: 'Word',
    description: 'Create a Word Template form',
  },
];

export const addNotificationTemplateList = [
  {
    icon: 'notification.png',
    link: 'notification',
    title: 'Notification',
    description:
      'Sends email or SMS notifications when records meeting certain criteria are added or modified',
  },
  {
    icon: 'subscription.png',
    link: 'subscription',
    title: 'Subscription',
    description:
      'Periodically email a selected report on a daily, weekly or monthly basis',
  },
  {
    icon: 'webhook.png',
    link: 'webhook',
    title: 'Webhook',
    description:
      'Sends record output when records meeting certain criteria are added or modified',
  },
  {
    icon: 'process.png',
    link: 'process',
    title: 'Process',
    description:
      'Execute a Process when a record is created or updated in datatable report',
  },
];
export const editRecordTemplateList = [
  {
    link: 'edit-record',
    title: 'Edit Record',
    conditional:true
  },
  {
    link: 'edit-form',
    title: 'Edit Form',
    conditional:false
  },
  {
    link: 'delete-record',
    title: 'Delete Record',
    conditional:true
  },
  {
    link: 'copy-record',
    title: 'Copy Record',
  },
  // {
  //   link: 'email-record',
  //   title: 'Email Record',
  // },
  {
    link: 'print-record',
    title: 'Print Record',
    conditional: true
  },
  // {
  //   link: 'next-record',
  //   title: 'Next Record',
  // },
  // {
  //   link: 'previous-record',
  //   title: 'Previous Record',
  // },
];
export const addRecordTemplateList = [
  {
    link: 'add-record',
    title: 'Add Record',
  },
  {
    link: 'edit-report',
    title: 'Edit Report',
  },
  {
    link: 'edit-form',
    title: 'Edit Form'
  }
];

export const editUserInterfaceTemplateList = [
  {
    link: 'edit-dashboard',
    title: 'Edit Dashboard',
  },
  {
    link: 'edit-page',
    title: 'Edit Page',
  },
  {
    link: 'edit-layout',
    title: 'Edit Layout',
  },
  {
    link: 'edit-theme',
    title: 'Edit Theme',
  },
];
